import { jsxs as e } from "react/jsx-runtime";
import { useMultiStyleConfig as o, Box as r } from "@chakra-ui/react";
const p = ({ activeStep: t }) => {
  const s = o("Steps");
  return /* @__PURE__ */ e(r, { role: "status", "aria-live": "polite", sx: s.status, children: [
    "Step ",
    t,
    " selected."
  ] });
};
export {
  p as StepsStatus
};
